const getTemplate = (tableId, ariaLabelledBy) => {
    const template = document.createElement('template');
    const ariaAttribute = ariaLabelledBy ? `aria-labelledby="${ariaLabelledBy}"` : '';
    template.innerHTML = `
        <table id="${tableId}" class="bk-table bk-table--common dataTable" ${ariaAttribute} role="grid">
            <thead>
                <tr></tr>
            </thead>
        </table>
    `;

    return template;
};

export default getTemplate;
